export default {
  manage_equipment: "Equipment",
  manage_equipmentsTable_equipmentName: "Equipment Name",
  manage_equipmentsTable_assignments: "Assignments",
  manage_equipmentsTable_search_by_equipment_name: "Search by Equipment Name"
};
